/**
 * Constantes da aplicação
 */

export const API_BASE_URL = import.meta.env.DEV
  ? ""
  : import.meta.env.VITE_API_URL || "http://localhost:8000";

export const API_BASE_URL_ASSETS = import.meta.env.VITE_API_BASE_URL_ASSETS || "";

export const STORAGE_KEYS = {
  TOKEN: 'token',
  USER: 'user',
  DARK_MODE: 'darkMode',
  PWA_DISMISS: 'pwaDismissed',
  SLA_ALERT_DISMISS: 'slaAlertDismissed',
  PUSH_REGISTRATION: 'lastPushRegistration',
} as const;

export const USER_LEVELS = {
  DEV: 'dev',
  ADMIN: 'admin',
  USUARIO: 'usuario',
} as const;

export const PAGINATION = {
  DEFAULT_ITEMS_PER_PAGE: 10,
  DEFAULT_PAGE: 1,
} as const;

export const TIMEOUTS = {
  DEFAULT: 30000,
  UPLOAD: 30000,
  AVATAR: 20000,
} as const;

